/**
 * 获取活动类型名称
 */
export default function getActivityType() {
  const hash: string = location.hash;
  const hastArray: Array<string> = hash.split('/');
  return hastArray[1];
}